import React from 'react';

/**
 * Element to add vertical spacing
 */
const CmsSpacer = ({ height }) => {
  return <div style={{ paddingBottom: `${height}px` }} />;
};
export default CmsSpacer;
